<template>
  <b-card no-body>
    <b-card-header class="email-detail-head">
      <div
        class="user-details d-flex justify-content-between align-items-center flex-wrap"
      >
        <b-avatar size="48" class="mr-75" />
        <div class="mail-items">
          <h5 class="mb-0">
            {{ message.data.sender_name }}
          </h5>
        </div>
      </div>
      <div class="mail-meta-item d-flex align-items-center">
        <small class="mail-date-time text-muted">{{
          calcDate(message.created_at)
        }}</small>
      </div>
    </b-card-header>

    <b-card-body class="mail-message-wrapper pt-2">
      <div
        class="mail-message"
        v-html="Array.isArray(message.data.content[0]) ? '' : message.data.content"
      />
    </b-card-body>

    <!-- <b-card-footer v-if="message.attachments && message.attachments.length">
      <div class="mail-attachments">
        <div class="d-flex align-items-center mb-1">
          <feather-icon icon="PaperclipIcon" size="16" />
          <h5 class="font-weight-bolder text-body mb-0 ml-50">
            {{ message.attachments.length }} Attachment{{
              message.attachments.length > 1 ? "s" : ""
            }}
          </h5>
        </div>

        <div class="d-flex flex-column">
          <b-link
            v-for="(attachment, index) in message.attachments"
            :key="index"
            :href="attachment.url"
            target="_blank"
            :class="{ 'mt-75': index }"
          >
            <b-img :src="attachment.thumbnail" width="16px" class="mr-50" />
            <span class="text-muted font-weight-bolder align-text-top">{{
              attachment.fileName
            }}</span>
            <span class="text-muted font-small-2 ml-25"
              >({{ attachment.size }})</span
            >
          </b-link>
        </div>
      </div>
    </b-card-footer> -->
  </b-card>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BCardFooter,
  BAvatar,
  BLink,
  BImg,
} from "bootstrap-vue";
import { formatDate } from "@core/utils/filter";

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BCard,
    BCardHeader,
    BCardBody,
    BCardFooter,
    BAvatar,
    BLink,
    BImg,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      formatDate,
    };
  },
};
</script>

<style></style>
